import { ImportFileType } from '@/coreDomainsModule/entities/unmanagedBusiness';
import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { IUnmanagedBusinessRepository } from '@/coreInfrastructureModule/interfaces/IUnmanagedBusinessRepository';

/**
 * ファイルタイプを指定して、一致する未管理業務を削除するユースケース
 */
export class DeleteByFileTypeUnmanagedBusinessUseCase {
  private repository: IUnmanagedBusinessRepository;

  /**
   * コンストラクタ
   * @param repository - 未管理の取引の永続化の責務を負うクラス
   */
  constructor(repository: IUnmanagedBusinessRepository) {
    this.repository = repository;
  }

  /**
   * 未管理の取引をファイルタイプで指定して削除する
   * @param fileType - 未管理の取引のファイルタイプ
   */
  public execute(fileType: ImportFileType[]): INetworkResult<void, Error> {
    try {
      return this.repository.deleteByFileType(fileType);
    } catch (error) {
      console.error(error);
      return {
        status: {
          type: 'error',
          error: Error('想定外のエラーが発生しました'),
        },
      }; // 基本的にはここには到達しないはず
    }
  }
}
